import { isStrayCypherExpr } from './stray'

/**
 * Detail bundle for a single `:Site` (`$siteId` param).
 *
 * Returns:
 *   - `s`             — the site node itself
 *   - `lineSummaries` — every top-level line on the site, each with
 *                       the `:Process` it instantiates (if any), its
 *                       direct subline count, and the equipment
 *                       count (including any `HAS_SUBLINE*0..`
 *                       descendants and nested `HAS_EQUIPMENT*1..8`
 *                       tooling — used for the per-line tile
 *                       headline number). The line detail page still
 *                       lists only direct `HAS_EQUIPMENT` children.
 *   - `feeds`         — the directed `Line -[:FEEDS]-> Line` edges
 *                       between this site's top-level lines, for the
 *                       connectivity diagram.
 *
 * Process fan-out is collapsed with `head(collect(distinct p))` before
 * the per-line summary is collected. Schema says a Line instantiates
 * exactly one Process; without the collapse, multiple `INSTANTIATES`
 * edges produce one summary map (and therefore one UI card) per
 * process for the same line.
 *
 * Bounded by `LIMIT 10000` (the per-id detail-query convention) — a
 * ceiling even the largest realistic site does not approach.
 */
export const PLANT_SITE_DETAIL_CYPHER = `
            MATCH (s:Site {id: $siteId})
            OPTIONAL MATCH (s)-[:HAS_LINE]->(l:Line)
            WITH s, collect(distinct l) AS lines
            UNWIND (CASE WHEN size(lines) = 0 THEN [null] ELSE lines END) AS lineNode
            OPTIONAL MATCH (lineNode)-[:INSTANTIATES]->(p:Process)
            WITH s, lines, lineNode, head(collect(distinct p)) AS process
            OPTIONAL MATCH (lineNode)-[:HAS_SUBLINE]->(child:Line)
            WITH s, lines, lineNode, process, count(distinct child) AS sublineCount
            OPTIONAL MATCH (lineNode)-[:HAS_SUBLINE*0..]->(scope:Line)
            OPTIONAL MATCH (scope)-[:HAS_EQUIPMENT*1..8]->(eq:Equipment)
            WITH s, lines, lineNode, process, sublineCount,
                 count(distinct eq) AS equipmentCount,
                 [eqId IN collect(distinct eq.id) WHERE eqId IS NOT NULL] AS equipmentIds
            WITH s, lines,
                 collect(distinct {
                   line: lineNode,
                   process: process,
                   sublineCount: sublineCount,
                   equipmentCount: equipmentCount,
                   equipmentIds: equipmentIds
                 }) AS lineSummaries
            OPTIONAL MATCH (a:Line)-[f:FEEDS]->(b:Line)
              WHERE a IN lines AND b IN lines
            RETURN s,
                   lineSummaries,
                   collect(distinct {
                     type: type(f),
                     source: a.id,
                     target: b.id,
                     props: properties(f)
                   }) AS feeds,
                   ${isStrayCypherExpr('s', 'Site')} AS isStray
            LIMIT 10000
          `
